import createSupportPin from 'admin/services/utils/createSupportPin';
import './supportPin.scss';

export const SupportPinComponentModule = angular
    .module('app.components.pageHeader.supportPin', [])
    .component('supportPin', {
        bindings: {
            phoneNumber: '<'
        },
        template: `
            <div class="support-pin" ng-if="$ctrl.supportPin">
                <div class="support-pin__label">
                    Support Pin
                </div>
                <div class="support-pin__number">
                    {{$ctrl.supportPin}}
                </div>
            </div>
            <md-button
                class="support-pin"
                ui-sref="myAccount"
                alt="my account"
                title="My Account"
                ng-if="!$ctrl.supportPin">
                <div class="support-pin__label">
                    Support Pin
                </div>
                <div class="support-pin__text">
                    Add phone number to get PIN
                </div>
            </md-button>
        `,
        controller: class SupportPinCtrl {
            constructor() {
                'ngInject';
            }

            $onInit() {
                if (this.phoneNumber) this.supportPin = createSupportPin(this.phoneNumber);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/supportPin/supportPin.js